import { render } from "./BannerCucumber.vue?vue&type=template&id=2435449a"
import script from "./BannerCucumber.vue?vue&type=script&lang=js"
export * from "./BannerCucumber.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__